var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card-list',{attrs:{"title":"Info Retur Penjualan","data-size":"10","data-url":"/api/v1/return/items","edit-route":"/return/sales-edit","data-headers":_vm.tHeaders}})}
var staticRenderFns = []

export { render, staticRenderFns }